import { Banner } from "@chef/components";
import { LoginForm } from "@chef/feature-auth";
import { Modal } from "@chef/smart-components";

import { intl } from "./CustomerExistsModal.Intl";

interface CustomerExistsModalProps {
  onClose: () => void;
  isOpen: boolean;
  initialLoginMethod: "email" | "telephone";
  initialTelephone?: string;
  initalEmail?: string;
}

export const CustomerExistsModal = ({
  onClose,
  isOpen,
  initialLoginMethod,
  initialTelephone,
  initalEmail,
}: CustomerExistsModalProps) => {
  return (
    <Modal
      name="customer-exists-modal"
      size="md"
      open={isOpen}
      onClose={onClose}
    >
      <div className="text-center">
        <Banner highlighted>
          <strong>
            {initialLoginMethod === "email"
              ? intl.EMAIL_IN_USE_BANNER_TEXT
              : intl.TELEPHONE_IN_USE_BANNER_TEXT}
          </strong>
        </Banner>

        <div className="flex flex-col items-center justify-center bg-white rounded-bl-lg rounded-br-lg sm:p-6 md:py-10 md:px-20">
          <h2 className="text-2xl">
            <strong>{intl.HEADER}</strong>
          </h2>
          <p className="py-2">{intl.LOGIN_OPTION}</p>

          <LoginForm
            initialEmail={initalEmail}
            initialTelephone={initialTelephone}
            initialLoginMethod={initialLoginMethod}
          />
        </div>
      </div>
    </Modal>
  );
};
